import {
  Box,
  Button,
  Container,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { brands } from "../data/brandsAndProjectsData";
import { ProjectInformationCard } from "../components/landing/section-portfolio/ProjectInformationCard";
import { CaseStudy } from "../components/landing/section-portfolio/CaseStudy";
import { useTypeOfProjectContext } from "../context/portafolioContext";
import { useEffect, useState } from "react";
import "../components/landing/Landing.css";

import { HeroPortfolioSection } from "../components/landing/section-portfolio/HeroPortfolioSection";
import heroImage from "../assets/portfolio-images/heroPortfolioImage.webp";
import { useLanguageContext } from "../context/languageContext";
import { textlanguages } from "../data/textOfThePage";
import { capitalizeFirstLetter } from "../helpers/capitalizeFirstLetter";
import { useScrollReveal } from "../helpers/ScrollReveal";

export const PortfolioPage = () => {
  const {
    companySelected,
    setCompanySelected,
    projectSelected,
    setProjectSelected,
  } = useTypeOfProjectContext();

  const [initial, setInitial] = useState(true);

  useScrollReveal([
    {
      selector: ".revealPortfolio",
      options: {
        distance: "100px",
        duration: 1000,
        easing: "ease-out",
        origin: "left",
        reset: false,
        interval: 500,
      },
    },
  ]);

  const { languageSelected } = useLanguageContext();
  const serviceText = textlanguages[languageSelected].header[2].service;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [value, setValue] = useState("");
  const [sectorValue, setSectorValue] = useState("");
  const [showFilter, setShowFilter] = useState(false);

  const handleChangeBrand = (event) => {
    setValue(event.target.value);
    setCompanySelected(event.target.value);
  };
  const handleChangeSector = (event) => {
    setSectorValue(event.target.value);
  };

  const companySectors = [
    ...new Set(brands[languageSelected].map((brand) => brand.industry)),
  ];
  const filteredBrands = brands[languageSelected].filter(
    (brand) => sectorValue === brand.industry
  );

  useEffect(() => {
    setInitial(false);
  }, []);

  return (
    <Container disableGutters maxWidth={false} className="landing-container">
      <HeroPortfolioSection
        text={capitalizeFirstLetter(serviceText)}
        image={heroImage}
      />
      <Box
        sx={{
          display: "flex",
          minHeight: "100vh",
          flexDirection: "column",
          alignItems: "center",
          mt: "60px",
        }}
      >
        <Button
          variant={"contained"}
          sx={{
            bgcolor: "#005587",
            width: { xs: "300px", md: "500px" },
            mb: "40px",
            "&:hover": {
              bgcolor: "#005587",
            },
          }}
          className={initial ? "revealPortfolio" : ""}
          onClick={() => {
            setShowFilter((value) => !value);
          }}
        >
          {textlanguages[languageSelected].portfolio.filterButton + ":"}
        </Button>
        <Box
          sx={{
            mb: "40px",
            display: showFilter ? "flex" : "none",
            gap: "50px",
            flexWrap: "wrap",
            justifyContent: { xs: "center" },
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "20px",
              flexDirection: { xs: "column", md: "row" },
            }}
          >
            <Typography
              sx={{
                fontWeight: "bold",
                fontSize: "18px",
                width: "94px",
              }}
              className={initial ? "revealPortfolio" : ""}
            >
              {textlanguages[languageSelected].portfolio.labelFilterIndustry +
                ":"}
            </Typography>
            <Select
              value={sectorValue}
              onChange={handleChangeSector}
              displayEmpty
              sx={{ width: "289px" }}
            >
              <MenuItem value="" disabled>
                {textlanguages[languageSelected].portfolio.inputLabelIndustry}
              </MenuItem>
              {companySectors.map((sector, idx) => (
                <MenuItem value={sector} key={idx}>
                  {sector}
                </MenuItem>
              ))}
            </Select>
          </Box>
          <Box
            sx={{
              display: sectorValue === "" ? "none" : "flex",
              alignItems: "center",
              gap: "20px",
              flexDirection: { xs: "column", md: "row" },
            }}
          >
            <Typography
              sx={{ fontWeight: "bold", fontSize: "18px", width: "94px" }}
            >
              {textlanguages[languageSelected].portfolio.labelFilterCompany +
                ":"}
            </Typography>
            <Select
              value={value}
              onChange={handleChangeBrand}
              displayEmpty
              sx={{ width: "289px" }}
            >
              <MenuItem value="" disabled>
                {textlanguages[languageSelected].portfolio.inputFilterCompany}
              </MenuItem>
              {filteredBrands.map((brand, idx) => (
                <MenuItem value={idx} key={brand.name}>
                  {brand.name}
                </MenuItem>
              ))}
            </Select>
          </Box>
        </Box>
        <Typography
          variant="h3"
          sx={{ color: "#005587", width: { xs: "90%" }, textAlign: "center" }}
          className={initial ? "revealPortfolio" : ""}
        >
          {`${textlanguages[languageSelected].portfolio.titleProject} ${brands[languageSelected][companySelected]?.name}`}
        </Typography>
        <Box
          sx={{
            display: "flex",
            bgcolor: "#F0F0F0",
            p: "5px",
            mx: { xs: "10px" },
            borderRadius: "20px",
            minHeight: "45px",
            minWidth: { xs: "300px", md: "500px" },
            mt: "40px",
          }}
          className={initial ? "revealPortfolio" : ""}
        >
          {brands[languageSelected][companySelected]?.projects.map(
            (project, index) => (
              <Typography
                sx={{
                  bgcolor: projectSelected === index && "#fff",
                  color: projectSelected === index ? "#444444" : "#afafaf",
                  borderRadius: "15px",
                  px: "10px",
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: `${
                    100 /
                    brands[languageSelected][companySelected]?.projects.length
                  }%`,
                }}
                onClick={() => setProjectSelected(index)}
                key={project.name}
              >
                {project.name.length > 22
                  ? brands[languageSelected][companySelected]?.projects
                      .length >= 3
                    ? project.name.slice(0, 15) + "..."
                    : brands[languageSelected][companySelected]?.projects
                        .length === 2
                    ? project.name.slice(0, 17) + "..."
                    : project.name.slice(0, 34) + "..."
                  : project.name}
              </Typography>
            )
          )}
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box
            className={initial ? "revealPortfolio" : ""}
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <ProjectInformationCard
              companySelected={companySelected}
              projectSelected={projectSelected}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              gap: "50px",
              width: "100%",
              flexWrap: "wrap",
              justifyContent: "center",
              mb: "50px",
            }}
          >
            {brands[languageSelected][companySelected]?.projects[
              projectSelected
            ].caseStudy.map((caseStudy) => (
              <CaseStudy
                title={caseStudy.title}
                description={caseStudy.description}
                image={caseStudy.image}
                key={caseStudy.title}
                initial={initial}
              />
            ))}
          </Box>
        </Box>
      </Box>
    </Container>
  );
};
